import React from 'react';
import NumberFormat from 'react-number-format';

interface DollarCellProps {
  value: number;
}

export const DollarCell = ({ value }: DollarCellProps) => {
  return <NumberFormat value={value.toFixed(2)} displayType='text' thousandSeparator={true} prefix={'$'} />;
};
